import { PoolerUser } from '../models/user';
import { Job } from '../models/job';
import { SexEnum } from '../models/sex.enum';
import { CarLicenseEnum } from '../models/carLicense.enum';
import { LanguageEnum } from '../models/language.enum';

// Used to do serverside checks if invitee can be invited on a job to add a layer of security
export function inviteeFitsJobCriteria(
  inviteeUser: PoolerUser,
  job: Job,
): boolean {
  if (!inviteeUser || !job) {
    return false;
  }
  const invitee = job.invitees?.find(
    (invitee) => invitee.userId === inviteeUser._id,
  );
  const transferOfInvitee = job.transfers?.find(
    (transfer) => transfer.targetCustomer.id === invitee?.customer.id,
  );

  // Get Criteria of Transfer or Job
  const sexCriteria =
    transferOfInvitee?.criteria && transferOfInvitee.criteria.sex !== undefined
      ? transferOfInvitee.criteria.sex
      : job.sex;
  const carCriteria =
    transferOfInvitee?.criteria && transferOfInvitee.criteria.car !== undefined
      ? transferOfInvitee.criteria.car
      : job.car;
  const languageCriteria =
    transferOfInvitee?.criteria &&
    transferOfInvitee.criteria.language !== undefined
      ? transferOfInvitee.criteria.language
      : job.language;
  const certificatesCriteria =
    transferOfInvitee?.criteria?.certificates || job.certificates || [];
  const specialitiesCriteria =
    transferOfInvitee?.criteria?.specialities || job.specialities || [];

  if (
    (sexCriteria || sexCriteria === SexEnum.FEMALE) &&
    inviteeUser.sex !== sexCriteria
  ) {
    return false;
  }
  if (
    (carCriteria || carCriteria === CarLicenseEnum.LICENSE_AVAILABLE) &&
    carCriteria !== inviteeUser.car
  ) {
    return false;
  }
  if (
    (languageCriteria || languageCriteria === LanguageEnum.DEUTSCH) &&
    !inviteeUser.languages?.includes(languageCriteria)
  ) {
    return false;
  }
  if (
    certificatesCriteria.length &&
    !inviteeUser.certificates?.some((certificate) =>
      certificatesCriteria.map((cert) => cert.id).includes(certificate.id),
    )
  ) {
    return false;
  }
  if (
    specialitiesCriteria.length &&
    !inviteeUser.specialities?.some((speciality) =>
      specialitiesCriteria.map((spec) => spec.id).includes(speciality.id),
    )
  ) {
    return false;
  }

  return true;
}
